// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1k40u","header":"ReportDetails_header__n1Yf4","title":"ReportDetails_title__3qvJJ","left":"ReportDetails_left__7QvH7"};